/**
 * [INPUT]: 依赖 react-router 的 MetaFunction/LinksFunction；依赖 ../../src 的 LegalPage + SEO 真源
 * [OUTPUT]: /privacy 路由 —— 渲染 LegalPage page="privacy"；meta/links 注入 ROUTE_SEO.privacy head
 * [POS]: apps/web/app/routes 的法律页之一；预渲染目标
 * [PROTOCOL]: 变更时更新本头部，然后检查 ../CLAUDE.md
 */
import type { LinksFunction, MetaFunction } from 'react-router'
import { LegalPage } from '../../src/components/LegalPage'
import { ROUTE_SEO, buildLinks, buildMeta } from '../../src/seo'

export const meta: MetaFunction = () => buildMeta(ROUTE_SEO.privacy)
export const links: LinksFunction = () => buildLinks(ROUTE_SEO.privacy)

export default function PrivacyRoute() {
  return <LegalPage page="privacy" />
}